import { readNarrationPlan } from "./narrationPlan";
import { NarrationDirectorReviews } from "./NarrationDirectorReviews";

export function NarrationPlanPanel({
  manifest,
  onSeek,
  workloadId,
  finalVideoKey,
}: {
  manifest: unknown;
  onSeek: (seconds: number) => void;
  workloadId?: string | null;
  finalVideoKey?: string | null;
}) {
  const plan = readNarrationPlan(manifest, { workloadId, finalVideoKey });
  if (!plan) return null;
  return (
    <details className="mt-3 rounded border p-3 text-xs">
      <summary className="cursor-pointer font-medium">
        Narration decisions · revision {plan.revision} · delivery{" "}
        {plan.deliveryStatus}
      </summary>
      <div className="mt-2 space-y-2">
        <NarrationDirectorReviews reviews={plan.directorReviews} />
        {plan.directorReviewHistory.length > 0 && (
          <details>
            <summary className="cursor-pointer">
              Earlier director reviews ({plan.directorReviewHistory.length})
            </summary>
            <NarrationDirectorReviews reviews={plan.directorReviewHistory} />
          </details>
        )}
        {plan.direction && (
          <div className="space-y-2 border-b pb-3">
            <p>
              <strong>Story:</strong> {plan.direction.throughline}
            </p>
            <p>
              <strong>Narrator:</strong> {plan.direction.pointOfView}
            </p>
            <ol className="list-decimal space-y-2 pl-4">
              {plan.direction.beats.map((beat) => (
                <li key={beat.id}>
                  <p>
                    <strong>Scenes {beat.scenes.join(", ")}:</strong>{" "}
                    {beat.intent}
                  </p>
                  <p className="text-muted-foreground">{beat.connection}</p>
                  {beat.lines.length ? (
                    beat.lines.map((line, index) => <p key={index}>“{line}”</p>)
                  ) : (
                    <p className="text-muted-foreground">
                      Pictures and music · no narration
                    </p>
                  )}
                </li>
              ))}
            </ol>
          </div>
        )}
        {plan.groups.map((group) => (
          <p key={group.id}>
            <strong>
              Scenes {group.scenes.join(", ")}
              {group.silent ? " · silent" : ""}:
            </strong>{" "}
            {group.reason}
          </p>
        ))}
        {plan.phrases.map((phrase, index) => (
          <button
            key={`${phrase.unitId}-${index}`}
            type="button"
            className="block text-left underline"
            onClick={() => onSeek(phrase.start)}
          >
            {phrase.start.toFixed(2)}–{phrase.end.toFixed(2)}s · “{phrase.text}”
            · scenes {phrase.scenes.join(", ")}
          </button>
        ))}
        {plan.repairs.length > 0 && (
          <p>
            Speech repairs:{" "}
            {plan.repairs
              .map((r) => `${r.unitId}: ${r.action.replaceAll("_", " ")}`)
              .join("; ")}
          </p>
        )}
        <p className="text-muted-foreground">
          Plan {plan.digest.slice(0, 12)} · times refer to the delivered video.
        </p>
      </div>
    </details>
  );
}
